import { defineStore } from 'pinia';
import { useFetch } from '#app';
import type { ICallForward, ISettingsForwardDefineStore } from '~/types/settings/Forward';
import { useToastStore } from "@/stores/toast";

export const useSettingsForwardStore = defineStore('SettingsForwardStore', {
    state: (): ISettingsForwardDefineStore => ({
        error: null,
        callForward: [],
    }),
    getters: {},
    actions: {
        async getCallForward() {
            const toastStore = useToastStore();
            try {
                const { data, error } = await useFetch<ICallForward[]>('/api/settings/forward/callForward');
                this.error = error;
                if (error && error.value?.statusCode) {
                    throw error;
                }

                this.callForward = data.value;
                return true
            } catch (err: any) {
                this.error = err;
                toastStore.showAlert({
                    title: "canNotConnectToServer",
                    showCloseButton: true,
                    timerProgressBar: true,
                    type: "error"
                });
                return false
            }
        },
        async postCallForward(params: ICallForward) {
            const toastStore = useToastStore();
            try {
                for (let i = 0; this.callForward && i < this.callForward.length; i++) {
                    if (this.callForward[i].destination_data == params.destination_data) {
                        this.error = "theEnteredNumberIsDuplicate";
                        toastStore.showAlert({
                            title: this.error,
                            showCloseButton: true,
                            timerProgressBar: true,
                            type: "error"
                          });
                        return false;
                    }
                }

                const { error } = await useFetch<any>('/api/settings/forward/callForwardPost', {
                    method: 'POST',
                    body: params
                });
                this.error = error;
                if (error && error.value?.statusCode) {
                    throw error;
                }

                await this.getCallForward();
                toastStore.showAlert({
                    title: "callforwardInsertSuccessfully",
                    showCloseButton: true,
                    timerProgressBar: true,
                });
                return true
            } catch (err: any) {
                this.error = err;
                toastStore.showAlert({
                    title: "canNotConnectToServer",
                    showCloseButton: true,
                    timerProgressBar: true,
                    type: "error"
                });
                return false
            }
        },
        async deleteCallForward(params: ICallForward) {
            const toastStore = useToastStore();
            try {
                const { error } = await useFetch<any>('/api/settings/forward/callForwardDelete', {
                    method: 'DELETE',
                    body: params
                });
                this.error = error;
                if (error && error.value?.statusCode) {
                    throw error;
                }
                
                this.callForward = this.callForward?.filter(item => item.destination_uuid != params.destination_uuid);
                toastStore.showAlert({
                    title: "callforwardDeleteSuccessfully",
                    showCloseButton: true,
                    timerProgressBar: true,
                });
                return true
            } catch (err: any) {
                this.error = err;
                toastStore.showAlert({
                    title: "canNotConnectToServer",
                    showCloseButton: true,
                    timerProgressBar: true,
                    type: "error"
                });
                return false
            }
        },
    },

    persist: {
        storage: persistedState.localStorage,
    },
});
